var _defs, _desc, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStopbutton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    fill: "none",
    id: "Stop-Button-Flat--Streamline-Fluent-Emoji",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2"
  })), _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc1"
  }, "Stop Button Flat Streamline Emoji: https://streamlinehq.com")), /*#__PURE__*/React.createElement("path", {
    d: "M 0,4 C 0,1.79086 1.79086,0 4,0 h 20 c 2.2091,0 4,1.79086 4,4 v 20 c 0,2.2091 -1.7909,4 -4,4 H 4 C 1.79086,28 0,26.2091 0,24 Z",
    fill: "#eb0c2c",
    strokeWidth: 1,
    id: "path1",
    style: {
      display: "inline",
      fill: "#eb0c2c",
      fillOpacity: 1
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 6,7.5 C 6,6.67157 6.67157,6 7.5,6 h 13 C 21.3284,6 22,6.67157 22,7.5 v 13 C 22,21.3284 21.3284,22 20.5,22 H 7.5 C 6.67157,22 6,21.3284 6,20.5 Z",
    fill: "#ffffff",
    strokeWidth: 1,
    id: "path2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopbutton);
export default __webpack_public_path__ + "static/media/stopbutton.518ceab1a926e6ef08ac125cd433ea28.svg";
export { ForwardRef as ReactComponent };